import { getBackendUrl } from '../config/api';
import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API = `${getBackendUrl()}/api`;

const MySalarySlips = () => {
  const [salarySlips, setSalarySlips] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchSalarySlips();
  }, []);

  const fetchSalarySlips = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        setError('Please login to view salary slips');
        setLoading(false);
        return;
      }

      // Use personal_view=true to ensure all users (including admins) see only their own slips
      const response = await axios.get(`${API}/payroll/salary-slips?personal_view=true`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      setSalarySlips(response.data || []);
      setError(null);
    } catch (err) {
      console.error('Error fetching salary slips:', err);
      setError('Failed to load salary slips');
    } finally {
      setLoading(false);
    }
  };

  const handleDownload = async (slipId) => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API}/payroll/salary-slips/${slipId}/pdf`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      const newWindow = window.open('', '_blank');
      if (newWindow) {
        newWindow.document.write(response.data.html_content || 'Content not available');
        newWindow.document.close();
      } else {
        alert('Please allow pop-ups to view salary slip');
      }
    } catch (err) {
      console.error('Error downloading:', err);
      alert('Failed to download salary slip');
    }
  };

  if (loading) {
    return (
      <div className="p-6">
        <div className="text-center py-12">
          <div className="text-lg text-gray-600">Loading salary slips...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">My Salary Slips</h1>
        <p className="text-gray-600 mt-1">View and download your published salary slips</p>
      </div>

      {error && (
        <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
          <p className="text-red-800">{error}</p>
        </div>
      )}

      {!error && salarySlips.length === 0 && (
        <div className="bg-white shadow rounded-lg p-12 text-center">
          <svg className="w-16 h-16 mx-auto mb-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
          <h3 className="text-lg font-semibold mb-2">No Salary Slips Available</h3>
          <p className="text-gray-600">You don't have any published salary slips yet.</p>
        </div>
      )}

      {salarySlips.length > 0 && (
        <div className="space-y-4">
          {salarySlips.map(slip => (
            <div key={slip.id} className="bg-white shadow rounded-lg p-6 hover:shadow-lg transition-shadow">
              <div className="flex items-center justify-between">
                <div className="flex-1">
                  <div className="flex items-center space-x-3 mb-3">
                    <h3 className="text-xl font-semibold text-gray-900">
                      {new Date(slip.month + '-01').toLocaleDateString('en-US', { month: 'long', year: 'numeric' })}
                    </h3>
                    <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
                      Published
                    </span>
                  </div>
                  <div className="grid grid-cols-2 gap-4 text-sm">
                    <div>
                      <span className="text-gray-600">Net Salary: </span>
                      <span className="font-semibold text-lg text-green-600">₹{slip.net_salary?.toLocaleString()}</span>
                    </div>
                    <div>
                      <span className="text-gray-600">Published: </span>
                      <span className="text-gray-900">{new Date(slip.published_at).toLocaleDateString()}</span>
                    </div>
                  </div>
                </div>
                <div>
                  <button
                    onClick={() => handleDownload(slip.id)}
                    className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700"
                  >
                    <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                    </svg>
                    Download PDF
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MySalarySlips;
